import type { MouseEvent } from "react";
import { useEffect } from "react";

import { Alert } from "@Components/Icons/Alert";
import type { IAjax } from "@Components/Modules/Ajax";
import { requestTrack } from "@Components/Modules/Helpers";

import type { IButtonsBar } from "../common/ButtonsBar";
import { ButtonsBar } from "../common/ButtonsBar";
import type { INavigationModalActions } from "../common/NavigationModal";

import * as cssNavModal from "../common/NavigationModal.module.css";
import * as css from "./EmailVerificationForm.module.css";

export interface IEmailVerificationForm extends INavigationModalActions<any>, IAjax {
    title: string;
    yourEmailLabel: string;
    email: string;
    description: string;
    buttonsBar: IButtonsBar;
    ajaxVisualAction: string;
}

export const EmailVerificationForm = (props: IEmailVerificationForm) => {
    const buttonsBar: IButtonsBar = props.buttonsBar && {
        ...props.buttonsBar,
        nextButton: props.buttonsBar.nextButton && {
            ...props.buttonsBar.nextButton,
            onClick: () => props.onSubmit && props.onSubmit(),
        },
        cancelButton: props.buttonsBar.cancelButton && {
            ...props.buttonsBar.cancelButton,
            onClick: (ev: MouseEvent<HTMLAnchorElement>): void => {
                ev.preventDefault();
                if (props.onSubmit) {
                    props.onSubmit(4);
                }
            },
        },
    };

    useEffect(() => requestTrack(props.ajaxVisualAction), []);

    return (
        <div className={`${css.emailVerificationFormComponent} ${cssNavModal.standardModalForm}`}>
            <h1 className={`${cssNavModal.standardModalTitle} ${css.standardModalHeader}`}>{props.title}</h1>
            <div className={`${cssNavModal.standardModalFormBody} ${css.standardModalFormEmail}`}>
                <Alert iconAppearance="Gray" className={css.alertItem} />
                {props.email && (
                    <>
                        <span className={css.emailLabel}>{props.yourEmailLabel}</span>
                        <span className={css.email}>{props.email}</span>
                    </>
                )}
                <p className={css.description} dangerouslySetInnerHTML={{ __html: props.description }} />
            </div>
            <ButtonsBar {...buttonsBar} className={css.buttonsBar} />
        </div>
    );
};
